<template>
  <div class="alipay-anxin-card">
    <el-tooltip
      :disabled="socialRiskInfo === null"
      :content="riskTip"
      placement="top"
    >
      <span
        class="risk-dot"
        :class="riskClass"
      />
    </el-tooltip>
    <el-button
      type="text"
      size="small"
      @click="showModal"
    >
      支付宝扫码自动录入
    </el-button>

    <el-dialog
      title="支付宝扫码查询"
      :visible="dialogVisible"
      width="420px"
      :append-to-body="true"
      :close-on-click-modal="false"
      @update:visible="dialogVisible = $event"
      @close="handleDialogClose"
    >
      <div class="qr-container">
        <div class="qr-card">
          <canvas
            ref="qrCanvas"
            class="qr-canvas"
          />
        </div>
        <span class="qr-tip">使用支付宝扫码，自动录入姓名、身份证号、手机号信息。</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRious from 'qrious'
import { getCustomerInfoByOutRegisterId } from '@/api/domain/customers'

const POLLING_INTERVAL = 2000
const ALIPAY_ANXIN_CARD_APP_ID = '2021005195689424'
const QR_CODE_SIZE = 260

export default {
  name: 'AlipayAnxinCard',
  data() {
    return {
      dialogVisible: false,
      outRegisterId: '',
      qrCodeUrl: '',
      pollTimer: null,
      polling: false,
      socialRiskInfo: null,
    }
  },
  computed: {
    riskClass() {
      if (this.socialRiskInfo === false) {
        return 'is-safe'
      }
      if (this.socialRiskInfo === true) {
        return 'is-risk'
      }
      return ''
    },
    riskTip() {
      if (this.socialRiskInfo === false) {
        return '安心卡风险结果：正常'
      }
      if (this.socialRiskInfo === true) {
        return '安心卡风险结果：存在风险'
      }
      return ''
    },
  },
  // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
  beforeDestroy() {
    this.stopPolling()
  },
  methods: {
    generateUniqueId() {
      const timestamp = Date.now().toString()
      const random = Math.random().toString(36).substring(2, 8)
      return `${timestamp}${random}`
    },
    buildQrCodeUrl(outRegisterId) {
      return `alipays://platformapi/startapp?appId=${ALIPAY_ANXIN_CARD_APP_ID}&appVersion=develop&page=pages/index/index&query=outRegisterNo%3D${encodeURIComponent(outRegisterId)}&enableKeepAlive=NO`
    },
    showModal() {
      this.outRegisterId = this.generateUniqueId()
      this.qrCodeUrl = this.buildQrCodeUrl(this.outRegisterId)
      this.dialogVisible = true
      this.$nextTick(() => {
        this.renderQrCode()
        this.startPolling()
      })
    },
    renderQrCode() {
      if (!this.$refs.qrCanvas || !this.qrCodeUrl) return
      // eslint-disable-next-line no-new
      new QRious({
        element: this.$refs.qrCanvas,
        value: this.qrCodeUrl,
        size: QR_CODE_SIZE,
      })
    },
    startPolling() {
      this.stopPolling()
      this.pollTimer = window.setInterval(this.pollCustomerInfo, POLLING_INTERVAL)
    },
    stopPolling() {
      if (this.pollTimer) {
        window.clearInterval(this.pollTimer)
        this.pollTimer = null
      }
      this.polling = false
    },
    async pollCustomerInfo() {
      if (this.polling || !this.outRegisterId) return
      this.polling = true
      try {
        const res = await getCustomerInfoByOutRegisterId(this.outRegisterId)
        if (res?.code === 1 && res.data) {
          this.handleScanSuccess(res.data)
        }
      } catch (error) {
        // 轮询期间服务端未查到数据或网络短暂异常不打断扫码流程。
      } finally {
        this.polling = false
      }
    },
    handleScanSuccess(data) {
      if (Object.prototype.hasOwnProperty.call(data, 'social_risk_info')) {
        this.socialRiskInfo = data.social_risk_info
      }
      this.stopPolling()
      this.dialogVisible = false
      this.$emit('data', data)
      this.$message({
        message: '支付宝安心卡信息已录入',
        type: 'success',
      })
    },
    handleDialogClose() {
      this.stopPolling()
    },
  },
}
</script>

<style lang="scss" scoped>
.alipay-anxin-card {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.risk-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 8px;
  border-radius: 50%;
  background: #d9d9d9;

  &.is-safe {
    background: #52c41a;
  }

  &.is-risk {
    background: #ff4d4f;
  }
}

.qr-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  text-align: center;
}

.qr-card {
  padding: 12px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.qr-canvas {
  display: block;
}

.qr-tip {
  display: block;
  margin-top: 14px;
  color: #606266;
  font-size: 14px;
  line-height: 20px;
}
</style>
